import { Box, Typography } from '@mui/material';

import {
  FORTA_GRAY4,
  FORTA_BLUE,
  FORTA_ERROR,
  FORTA_SUCCESS,
  FORTA_WHITE,
  FORTA_YELLOW,
} from '../../../../utils/colors';
import { oneWeek } from '../constants';
import BtIcon from '../../../svgs/BtIcon';
import SeparatorIcon from '../../../svgs/SeparatorIcon';
import CompletedIcon from '../../../svgs/CompletedIcon';
import ReviewStatus from './ReviewStatus';
import { FHSkeletonLoader } from '../../../base';

interface IQAStatusCardProps {
  loading?: boolean;
  btName?: string;
  selected: boolean;
  reviewPendingDurationInDays: number;
  numFailedReviews: number;
}

function QAStatusCard(props: IQAStatusCardProps) {
  const { loading, btName, selected, reviewPendingDurationInDays, numFailedReviews } = props;
  const newBt = reviewPendingDurationInDays === null; // BE agreed reviewPendingDurationInDays to be null for new bt's
  return (
    <Box
      sx={{
        borderRadius: '8px',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
        px: 2,
        py: 1,
        backgroundColor: selected ? FORTA_BLUE.light1 : FORTA_WHITE,
        height: '64px',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {newBt && !loading && (
        <Box
          sx={{
            position: 'absolute',
            backgroundColor: FORTA_SUCCESS,
            borderRadius: '8px',
            right: '2px',
            top: '-5px',
            fontSize: '8px',
            lineHeight: '150%',
            fontWeight: '700',
            color: FORTA_WHITE,
            width: '36px',
            height: '16px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          New
        </Box>
      )}
      {loading ? (
        <FHSkeletonLoader variant="circular" width={24} height={24} />
      ) : (
        <BtIcon color={selected ? FORTA_WHITE : FORTA_BLUE.light1} />
      )}
      {loading ? (
        <FHSkeletonLoader variant="circular" width={140} />
      ) : (
        <Typography
          variant="body1"
          align="left"
          sx={{
            mr: 2,
            ml: 1,
            fontWeight: '400',
            width: '140px',
            color: selected ? FORTA_WHITE : FORTA_GRAY4,
          }}
        >
          {btName}
        </Typography>
      )}
      <Box sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>{<SeparatorIcon />}</Box>
      <Box sx={{ mr: 2, display: 'flex' }}>
        {newBt || reviewPendingDurationInDays > oneWeek ? (
          <ReviewStatus
            sx={{
              border: newBt ? `2px solid ${FORTA_BLUE.bright}` : 'none',
              backgroundColor: newBt
                ? 'none'
                : reviewPendingDurationInDays > oneWeek
                  ? FORTA_YELLOW
                  : FORTA_SUCCESS,
            }}
            content={newBt ? '' : reviewPendingDurationInDays}
          ></ReviewStatus>
        ) : (
          <CompletedIcon data-testid={FORTA_SUCCESS} color={FORTA_SUCCESS} />
        )}
      </Box>
      <Box sx={{ mr: 2 }}>
        <ReviewStatus
          content={numFailedReviews}
          sx={{
            backgroundColor: numFailedReviews > 0 ? FORTA_ERROR : FORTA_BLUE.bright,
          }}
        ></ReviewStatus>
      </Box>
    </Box>
  );
}

export default QAStatusCard;
